import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  AccountBookOutline,
  AlertOutline,
  ApiOutline,
  ApiTwoTone,
  AppstoreAddOutline,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  ArrowUpOutline,
  AuditOutline,
  BankOutline,
  BankTwoTone,
  BarChartOutline,
  BarcodeOutline,
  BarsOutline,
  BellTwoTone,
  BlockOutline,
  BookTwoTone,
  BuildOutline,
  BulbOutline,
  BulbTwoTone,
  CalendarOutline,
  CaretDownOutline,
  CaretRightOutline,
  CheckCircleOutline,
  CheckCircleTwoTone,
  CheckOutline,
  CheckSquareOutline,
  ClockCircleOutline,
  CloseCircleFill,
  CloseCircleOutline,
  CloseCircleTwoTone,
  CloseOutline,
  CloudSyncOutline,
  CommentOutline,
  ContactsOutline,
  ContactsTwoTone,
  ContainerOutline,
  ControlOutline,
  CopyOutline,
  CopyTwoTone,
  CustomerServiceOutline,
  CustomerServiceTwoTone,
  DashboardOutline,
  DeleteOutline,
  DeleteTwoTone,
  DeploymentUnitOutline,
  DisconnectOutline,
  DollarOutline,
  DoubleLeftOutline,
  DoubleRightOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EditTwoTone,
  EllipsisOutline,
  EnvironmentOutline,
  ExclamationCircleOutline,
  ExportOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FieldBinaryOutline,
  FieldTimeOutline,
  FileAddOutline,
  FileDoneOutline,
  FileExcelOutline,
  FileImageOutline,
  FileOutline,
  FilePdfOutline,
  FilePdfTwoTone,
  FileSearchOutline,
  FileSyncOutline,
  FileTextOutline,
  FileTextTwoTone,
  FileUnknownOutline,
  FileWordOutline,
  FileZipOutline,
  FilterOutline,
  FolderOpenOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GlobalOutline,
  GoogleOutline,
  GroupOutline,
  HistoryOutline,
  HomeTwoTone,
  IdcardOutline,
  IdcardTwoTone,
  ImportOutline,
  InboxOutline,
  InfoCircleFill,
  InfoCircleOutline,
  InfoCircleTwoTone,
  InsertRowAboveOutline,
  ItalicOutline,
  LayoutOutline,
  LineChartOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  MailOutline,
  MailTwoTone,
  MenuOutline,
  MergeCellsOutline,
  MessageOutline,
  MessageTwoTone,
  MinusOutline,
  MinusSquareTwoTone,
  MobileOutline,
  MobileTwoTone,
  MoneyCollectOutline,
  MoreOutline,
  NumberOutline,
  PaperClipOutline,
  PartitionOutline,
  PhoneTwoTone,
  PlusOutline,
  PlusSquareTwoTone,
  PoweroffOutline,
  ProfileOutline,
  ProjectOutline,
  ProjectTwoTone,
  PushpinOutline,
  RedoOutline,
  RetweetOutline,
  RightCircleOutline,
  RiseOutline,
  RotateLeftOutline,
  RotateRightOutline,
  SaveOutline,
  SearchOutline,
  SelectOutline,
  SendOutline,
  SettingOutline,
  SlidersOutline,
  SnippetsTwoTone,
  StarTwoTone,
  StockOutline,
  StopOutline,
  SwapOutline,
  SwapRightOutline,
  SyncOutline,
  TableOutline,
  TeamOutline,
  ThunderboltTwoTone,
  UndoOutline,
  UnlockOutline,
  UnorderedListOutline,
  UploadOutline,
  UserOutline,
  UsergroupAddOutline,
  WarningFill,
  WarningOutline,
  WhatsAppOutline
} from '@ant-design/icons-angular/icons';

// Statically registering every icon type actually used in the app avoids ng-zorro's
// default fallback: fetching each unregistered icon as an individual HTTP request to
// /assets/{theme}/{name}.svg at render time. That fallback was firing ~20 separate
// round trips per page load (see perf investigation) purely for icons this list
// already knows about ahead of time.
const icons = [
  MenuFoldOutline, MenuUnfoldOutline, FormOutline, DashboardOutline,
  AccountBookOutline, AlertOutline, ApiOutline, ApiTwoTone, AppstoreAddOutline, AppstoreOutline,
  ArrowDownOutline, ArrowLeftOutline, ArrowRightOutline, ArrowUpOutline, AuditOutline,
  BankOutline, BankTwoTone, BarChartOutline, BarcodeOutline, BarsOutline, BellTwoTone,
  BlockOutline, BookTwoTone, BuildOutline, BulbOutline, BulbTwoTone,
  CalendarOutline, CaretDownOutline, CaretRightOutline, CheckCircleOutline, CheckCircleTwoTone,
  CheckOutline, CheckSquareOutline, ClockCircleOutline, CloseCircleFill, CloseCircleOutline,
  CloseCircleTwoTone, CloseOutline, CloudSyncOutline, CommentOutline, ContactsOutline,
  ContactsTwoTone, ContainerOutline, ControlOutline, CopyOutline, CopyTwoTone,
  CustomerServiceOutline, CustomerServiceTwoTone, DeleteOutline, DeleteTwoTone,
  DeploymentUnitOutline, DisconnectOutline, DollarOutline, DoubleLeftOutline, DoubleRightOutline,
  DownOutline, DownloadOutline, EditOutline, EditTwoTone, EllipsisOutline, EnvironmentOutline,
  ExclamationCircleOutline, ExportOutline, EyeInvisibleOutline, EyeOutline, FieldBinaryOutline,
  FieldTimeOutline, FileAddOutline, FileDoneOutline, FileExcelOutline, FileImageOutline,
  FileOutline, FilePdfOutline, FilePdfTwoTone, FileSearchOutline, FileSyncOutline,
  FileTextOutline, FileTextTwoTone, FileUnknownOutline, FileWordOutline, FileZipOutline,
  FilterOutline, FolderOpenOutline, FullscreenExitOutline, FullscreenOutline, GlobalOutline,
  GoogleOutline, GroupOutline, HistoryOutline, HomeTwoTone, IdcardOutline, IdcardTwoTone,
  ImportOutline, InboxOutline, InfoCircleFill, InfoCircleOutline, InfoCircleTwoTone,
  InsertRowAboveOutline, ItalicOutline, LayoutOutline, LineChartOutline, LinkOutline,
  LoadingOutline, LockOutline, MailOutline, MailTwoTone, MenuOutline, MergeCellsOutline,
  MessageOutline, MessageTwoTone, MinusOutline, MinusSquareTwoTone, MobileOutline, MobileTwoTone,
  MoneyCollectOutline, MoreOutline, NumberOutline, PaperClipOutline, PartitionOutline,
  PhoneTwoTone, PlusOutline, PlusSquareTwoTone, PoweroffOutline, ProfileOutline, ProjectOutline,
  ProjectTwoTone, PushpinOutline, RedoOutline, RetweetOutline, RightCircleOutline, RiseOutline,
  RotateLeftOutline, RotateRightOutline, SaveOutline, SearchOutline, SelectOutline, SendOutline,
  SettingOutline, SlidersOutline, SnippetsTwoTone, StarTwoTone, StockOutline, StopOutline,
  SwapOutline, SwapRightOutline, SyncOutline, TableOutline, TeamOutline, ThunderboltTwoTone,
  UndoOutline, UnlockOutline, UnorderedListOutline, UploadOutline, UserOutline,
  UsergroupAddOutline, WarningFill, WarningOutline, WhatsAppOutline,
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [
    { provide: NZ_ICONS, useValue: icons }
  ]
})
export class IconsProviderModule {
}
